import { Component, ElementRef, OnInit, Output, ViewChild, EventEmitter, Input, OnChanges } from '@angular/core';

import { GlobalConstants } from './../../../common/constants/global.constant';

@Component({
  selector: 'iposcen-ipos-help-device',
  templateUrl: './ipos-help-device.component.html',
  styleUrls: ['./ipos-help-device.component.scss']
})
export class IposHelpDeviceComponent implements OnInit, OnChanges {
  @ViewChild('devicesAcc') helpComp: ElementRef;
  @ViewChild('updateDevice') updateDevice: ElementRef;
  @ViewChild('activeDevice') activeDevice: ElementRef;
  @ViewChild('storeLogo') storeLogo: ElementRef;
  @ViewChild('deviceSetting') deviceSetting: ElementRef;
  @Output() readonly openComp = new EventEmitter();
  @Input() sideNavData;
  loginUserRole = sessionStorage.getItem('userRole');
  retailHQUser = GlobalConstants.RETAIL_HQ_USER;
  storeUser = GlobalConstants.STORE_USER;
  intelAdmin = GlobalConstants.INTEL_ADMIN;
  deviceExecutive = GlobalConstants.DEVICE_EXECUTIVE;
  isActiveDeviceReport = true;
  isUpdateDevices = true;
  isStoreLogo = true;
  isDeviceSetting = true;

  constructor() { }

  ngOnInit(): void {
  }
  showDescription(data) {
    if (data === 'activeDeviceReport') {
      this.isActiveDeviceReport = !this.isActiveDeviceReport;
    } else if (data === 'updateDevices') {
      this.isUpdateDevices = !this.isUpdateDevices;
    } else if (data === 'storeLogo') {
      this.isStoreLogo = !this.isStoreLogo;
    } else if (data === 'deviceSetting') {
      this.isDeviceSetting = !this.isDeviceSetting;
    }
  }

  ngOnChanges(): void {

  }

  change(data) {
    if (data === 'update') {
      setTimeout(() => {
        this.updateDevice.nativeElement.scrollIntoView();
      }, 0);
    } else if (data === 'report') {
      setTimeout(() => {
        this.activeDevice.nativeElement.scrollIntoView();
      }, 0);
    } else if (data === 'store') {
      setTimeout(() => {
        this.storeLogo.nativeElement.scrollIntoView();
      }, 0);
    } else if (data === 'setting') {
      setTimeout(() => {
        this.deviceSetting.nativeElement.scrollIntoView();
      }, 0);
    }
  }
  scroll(id) {
    this.helpComp.nativeElement.scrollIntoView();
  }
  openAssetLibrary(data, section) {
    this.openComp.emit([data, 'device', section]);
  }
}
